import { AnalyticIdentifier } from '@common/neo.tax';

import { useAnalyticId } from '@neo.tax/shared';

type RdProjectDisallowancesIds = {
  adaptationForCustomerId: string;
  internalUseSoftwareId: string;
  researchFundedByGrantContractEtcId: string;
  researchIntoSocialSciencesId: string;
  researchOutsideUsId: string;
  reverseEngineeringId: string;
  surveyOrMarketResearchId: string;
  testingOrQaInProductionId: string;
  noneOfTheAboveId: string;
};

export const useRdProjectDisallowancesIds = (): RdProjectDisallowancesIds => ({
  adaptationForCustomerId: useAnalyticId(AnalyticIdentifier.ENTERPRISE_PROJECT_ADAPTATION_FOR_CUSTOMER),
  internalUseSoftwareId: useAnalyticId(AnalyticIdentifier.ENTERPRISE_PROJECT_INTERNAL_USE_SOFTWARE),
  researchFundedByGrantContractEtcId: useAnalyticId(
    AnalyticIdentifier.ENTERPRISE_PROJECT_RESEARCH_FUNDED_BY_GRANT_CONTRACT_ETC,
  ),
  researchIntoSocialSciencesId: useAnalyticId(AnalyticIdentifier.ENTERPRISE_PROJECT_RESEARCH_INTO_SOCIAL_SCIENCES),
  researchOutsideUsId: useAnalyticId(AnalyticIdentifier.ENTERPRISE_PROJECT_RESEARCH_OUTSIDE_US),
  reverseEngineeringId: useAnalyticId(AnalyticIdentifier.ENTERPRISE_PROJECT_REVERSE_ENGINEERING),
  surveyOrMarketResearchId: useAnalyticId(AnalyticIdentifier.ENTERPRISE_PROJECT_SURVEY_OR_MARKET_RESEARCH),
  testingOrQaInProductionId: useAnalyticId(AnalyticIdentifier.ENTERPRISE_PROJECT_TESTING_OR_QA_IN_PRODUCTION),
  noneOfTheAboveId: useAnalyticId(AnalyticIdentifier.ENTERPRISE_PROJECT_NONE_OF_THE_ABOVE),
});
